import styled from 'styled-components';
import withTranslations from 'hocs/withTranslations';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { Row } from 'antd';
import PropTypes from 'prop-types';
import { actions as authActions, selectors as userSelectors } from 'store/modules/user';
import TranslationsContext from 'providers/translationsProvider';

import { Form, Button, Input, Modal } from 'components/elements';
import { P } from 'components/fontSystem';

const INPUT_EMAIL = 'email';

class ForgotPassword extends Component {
  static propTypes = {
    className: PropTypes.string,
    forgotPassword: PropTypes.func.isRequired,
    resetRequested: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    visible: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    resetRequested: false.Button,
    className: '',
  };

  formRef = React.createRef();

  static contextType = TranslationsContext;

  state = {
    email: '',
    validEmail: false,
  };

  handleOnFinish = values => {
    this.props.forgotPassword(
      String(this.state.email).toLowerCase() // Email should be in lower case
    );
  };

  handleOnChangeForm = ({ target }) => {
    this.setState({ email: target.value });
    this.formRef.current
      .validateFields([INPUT_EMAIL])
      .then(values => {
        this.setState({ validEmail: true });
      })
      .catch(errorInfo => {
        this.setState({ validEmail: false });
      });
  };

  render() {
    const { t } = this.context;
    const { onCancel, visible } = this.props;
    const modalClasses = `bold-title ${this.props.className}`;

    const formJSX = (
      <Form
        layout="vertical"
        ref={this.formRef}
        onFinish={this.handleOnFinish}
        onChange={this.handleOnChangeForm}
      >
        <Form.Item
          label={t("No problem, we'll send you reset instructions.")}
          noAsterisk
          rules={[
            {
              required: true,
              message: t('Enter a valid email here'),
              type: 'email',
            },
          ]}
          name={INPUT_EMAIL}
        >
          <Input placeholder={t('Enter a valid email here')} />
        </Form.Item>
        <Form.Item name="submit">
          <Row type="flex" justify="end">
            <Button
              size="large"
              type="primary"
              htmlType="submit"
              key="reset-submit"
              disabled={!this.state.validEmail}
            >
              {t('SUBMIT')}
            </Button>
          </Row>
        </Form.Item>
      </Form>
    );

    const title = this.props.resetRequested ? t('Help is on its way!') : t('Locked out?');

    return (
      <React.Fragment>
        <Modal
          className={modalClasses}
          closable={!this.props.resetRequested}
          title={title}
          open={visible}
          onOk={this.handleOk}
          onCancel={onCancel}
          footer={
            this.props.resetRequested ? (
              <Button size="large" type="primary" onClick={onCancel}>
                {t('GOT IT')}
              </Button>
            ) : null
          }
        >
          {this.props.resetRequested ? (
            <P>
              {t(
                "Reset password instructions have been sent. If you don't see the email soon, check your spam folder - it could have gotten lost along the way."
              )}
            </P>
          ) : (
            formJSX
          )}
        </Modal>
      </React.Fragment>
    );
  }
}

const StyledForgotPassword = styled(ForgotPassword)`
  @media (max-width: 768px) {
    .ant-modal-content {
      padding: 20px;
    }
  }
  .ant-row.ant-form-item:last-child {
    margin-bottom: 0;
  }
`;

const mapDispatchToProps = dispatch => ({
  forgotPassword: email => dispatch(authActions.forgotPassword({ email })),
});

const mapStateToProps = state => ({
  resetRequested: userSelectors.getForgotPasswordRequested(state),
});

const ConnectedForgotPassword = connect(mapStateToProps, mapDispatchToProps)(StyledForgotPassword);

export default withTranslations(ConnectedForgotPassword);
